import {Draggable, DraggableProps} from '@hello-pangea/dnd';
import React, {FC, ReactElement, ReactNode} from 'react';

export interface DragProps extends Omit<DraggableProps, 'children'> {
  isStep?: boolean;
  className: string;
  children: ReactNode;
  draggableElement: JSX.Element;
}
export const Drag: FC<DragProps> = ({
  draggableId,
  index,
  className,
  children,
  draggableElement,
  ...props
}): ReactElement => {
  if (!React.isValidElement(children)) return <div />;

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided) => {
        return (
          <div className={className} ref={provided.innerRef} {...provided.draggableProps} {...props}>
            <div className="drag-handle" {...provided.dragHandleProps}>
              {draggableElement}
            </div>
            {children}
          </div>
        );
      }}
    </Draggable>
  );
};
